var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.925781,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.925781,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#ECECF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7858 19.6357H19.2073V31.214H30.7858V19.6357Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7883 36.4262L35.9986 31.216L33.3935 30.7715L30.7883 31.216L30.3128 33.5988L30.7883 36.4262Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 31.216V34.6895C14.0003 35.649 14.7775 36.4262 15.7371 36.4262H19.2106L19.7456 33.8211L19.2106 31.216L16.372 30.7715L14.0003 31.216Z",
    fill: "#188038"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9986 19.636V16.1625C35.9986 15.203 35.2214 14.4258 34.2618 14.4258H30.7883C30.4713 15.7179 30.3128 16.6687 30.3128 17.2784C30.3128 17.888 30.4713 18.6739 30.7883 19.636C31.9406 19.966 32.809 20.131 33.3935 20.131C33.9779 20.131 34.8463 19.966 35.9986 19.636Z",
    fill: "#1967D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9997 19.6357H30.7894V31.214H35.9997V19.6357Z",
    fill: "#FBBC04"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7858 31.2139H19.2073V36.4241H30.7858V31.2139Z",
    fill: "#34A853"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7891 14.4258H15.7371C14.7775 14.4258 14.0003 15.203 14.0003 16.1625V31.2143H19.2106V19.636H30.7891V14.4258Z",
    fill: "#4285F4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5876 28.623C21.1548 28.3306 20.8553 27.9037 20.6917 27.3392L21.6961 26.9253C21.7873 27.2726 21.9465 27.5418 22.1738 27.7329C22.3995 27.9239 22.6745 28.018 22.9958 28.018C23.3244 28.018 23.6066 27.9181 23.8425 27.7184C24.0784 27.5187 24.1971 27.264 24.1971 26.9557C24.1971 26.6402 24.0726 26.3826 23.8237 26.1828C23.5747 25.9831 23.2621 25.8832 22.8887 25.8832H22.3084V24.889H22.8294C23.1507 24.889 23.4213 24.8021 23.6413 24.6284C23.8613 24.4548 23.9713 24.2174 23.9713 23.9149C23.9713 23.6457 23.8729 23.4315 23.6761 23.2709C23.4792 23.1102 23.2303 23.0292 22.9278 23.0292C22.6326 23.0292 22.3981 23.1073 22.2244 23.2651C22.0508 23.4233 21.9204 23.623 21.8452 23.8455L20.8509 23.4315C20.9826 23.0581 21.2243 22.7282 21.5789 22.443C21.9335 22.1579 22.3865 22.0146 22.9365 22.0146C23.3432 22.0146 23.7093 22.0928 24.0335 22.2506C24.3577 22.4083 24.6125 22.6269 24.7963 22.9047C24.9801 23.1841 25.0713 23.4967 25.0713 23.844C25.0713 24.1986 24.9859 24.4982 24.8151 24.7442C24.6443 24.9903 24.4344 25.1784 24.1855 25.3101V25.3695C24.5069 25.502 24.7862 25.7196 24.9931 25.999C25.203 26.2812 25.3086 26.6185 25.3086 27.0121C25.3086 27.4058 25.2088 27.7575 25.009 28.0658C24.8093 28.374 24.5329 28.6172 24.1826 28.7937C23.8309 28.9703 23.4358 29.06 22.9973 29.06C22.4893 29.0615 22.0203 28.9153 21.5876 28.623ZM27.7575 23.6385L26.6546 24.436L26.1032 23.5994L28.0817 22.1724H28.84V28.9037H27.7575V23.6385Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/googleCalendar.327d91defcb6ba0b0c06c65cf184b9e1.svg";
export { ForwardRef as ReactComponent };